import { loadFiles } from '../../loader-base/src/helpers';

/**
 * Check whether this is IE11
 */
function isIE11() {
    return Object.prototype.hasOwnProperty.call(window, 'ActiveXObject');
}

/**
 * Get the polyfill config based on the recommended value and config
 * @param {*} config - config options
 */
function getPolyfillConfig(config) {
    // If recommended is false just return the config as-is
    if (config.recommended === false) {
        return config;
    }

    // Combine the recommended polyfills with any other options passed in
    const combined = {
        polyfillio: {
            features: ['Intl.~locale.en', 'fetch', 'CustomEvent', 'URL', 'Array.prototype.forEach', 'String.prototype.startsWith'],
        },
        urls: [
            'https://cdnjs.cloudflare.com/ajax/libs/custom-elements/1.2.4/custom-elements.min.js',
            {
                test: isIE11,
                url: 'https://mwc-cdn.morningstar.com/lib/polyfill/native-shim-es5.js',
            },
        ],
    };

    // Combine polyfill.io features
    if (config.polyfillio) {
        combined.polyfillio.version = config.polyfillio.version;
        combined.polyfillio.callback = config.polyfillio.callback;
        if (config.polyfillio.features) {
            config.polyfillio.features.forEach((feature) => {
                if (combined.polyfillio.features.indexOf(feature) === -1) {
                    combined.polyfillio.features.push(feature);
                }
            });
        }
    }
    // Combine polyfill urls
    if (config.urls) {
        combined.urls = combined.urls.concat(config.urls);
    }
    return combined;
}

/**
 * Get the polyfill.io URL
 * @param {*} options
 */
function getPolyfillIoUrl(options) {
    let url = 'https://cdn.polyfill.io/v3/polyfill.min.js?';
    if (options.version) {
        url = `${url}version=${options.version}&`;
    }
    if (options.callback) {
        url = `${url}callback=${options.callback}&`;
    }
    url = `${url}features=${options.features.join('%2C')}`;
    return url;
}

/**
 * Load the specified polyfill files
 * @param {*} config - the config options for the polyfills to load
 */
function loadPolyfills(config) {
    const polyfillConfig = getPolyfillConfig(config);

    return new Promise((resolve, reject) => {
        const polyfills = [];

        // Add polyfill.io URL
        if (polyfillConfig.polyfillio) {
            polyfills.push(getPolyfillIoUrl(polyfillConfig.polyfillio));
        }

        if (polyfillConfig.urls) {
            polyfillConfig.urls.forEach((url) => {
                // get the polyfill url - can be string or object with url prop
                const polyfillUrl = url.url || url;
                // by default add the polyfill if it's not already in the list
                let addPolyfill = polyfills.indexOf(polyfillUrl) === -1;
                // If there is a test function for this url then run it
                if (url.test) {
                    addPolyfill = url.test();
                }
                if (addPolyfill) {
                    polyfills.push(polyfillUrl);
                }
            });
        }

        loadFiles(polyfills)
            .then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
    });
}

export default loadPolyfills;



// WEBPACK FOOTER //
// ./src/load-polyfills.js